import { gql, useLazyQuery } from '@apollo/client';

const GET_PIPEDRIVE_ORGANIZATION = gql`
  query GetPipedriveOrganization($pipedriveId: Int, $companyDomain: String) {
    getPipedriveOrganization(pipedriveId: $pipedriveId, companyDomain: $companyDomain) {
      organizationId
      deals {
        dealId
        title
        stage
        status
        lostReason
      }
    }
  }
`;

interface PipedriveDeal {
  dealId: number;
  title: string;
  stage?: string;
  status: string;
  lostReason?: string;
}

interface PipedriveOrganization {
  organizationId: number;
  deals?: PipedriveDeal[];
}

interface GetPipedriveOrganizationData {
  getPipedriveOrganization?: PipedriveOrganization;
}

interface GetPipedriveOrganizationVars {
  pipedriveId?: number;
  companyDomain?: string;
}

export const usePipedriveOrganization = () => {
  const [fetchData, { loading, error, data }] = useLazyQuery<
    GetPipedriveOrganizationData,
    GetPipedriveOrganizationVars
  >(GET_PIPEDRIVE_ORGANIZATION);

  const getPipedriveOrganization = (pipedriveId?: number, companyDomain?: string) => {
    fetchData({ variables: { pipedriveId, companyDomain } });
  };

  return {
    getPipedriveOrganization,
    pipedriveData: data?.getPipedriveOrganization,
    pipedriveLoading: loading,
    pipedriveError: error,
  };
};
